/*
  cart-title-clean.js

  Hides the internal "+addons.HASH" suffix from configurator variant
  titles in the visible cart UI (drawer, notification, /cart page).

  Why a JS asset and not a backend rename:
    The hash must stay in the actual variant title because Shopify
    requires unique variant titles per product. Two shelves at the
    same dimensions + finish but different add-on sets must resolve
    to distinct variants, and the hash is what makes them unique.
    Stripping it at the storage layer would collapse them.

  So we keep the hash in the variant title for dedupe and quietly
  hide it from view at render time. The mutation is idempotent and
  scoped — it only touches text nodes that match the exact pattern,
  so native Shopify products are never modified.

  Pattern matched (literal): " +addons." followed by 1–16 hex chars.
*/

(function () {
  'use strict';

  if (window.__slabCartTitleCleanLoaded) return;
  window.__slabCartTitleCleanLoaded = true;

  var SUFFIX_RE = /\s*\+addons\.[a-f0-9]{1,16}/gi;

  function cleanTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    var s = node.nodeValue;
    if (!s || s.indexOf('+addons.') === -1) return;
    var cleaned = s.replace(SUFFIX_RE, '');
    if (cleaned !== s) node.nodeValue = cleaned;
  }

  function cleanSubtree(root) {
    if (!root || !root.querySelectorAll) return;
    // TreeWalker is the cheapest way to visit only text nodes.
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) cleanTextNode(n);
  }

  function scheduleScan() {
    if (scheduleScan._t) return;
    scheduleScan._t = setTimeout(function () {
      scheduleScan._t = null;
      cleanSubtree(document.body);
    }, 30);
  }

  // First pass once the DOM is parseable.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleScan);
  } else {
    scheduleScan();
  }

  // Re-scan whenever the cart re-renders. Focal swaps section HTML in
  // place on cart-add and cart-update; a MutationObserver on body
  // catches every replaced subtree without us having to enumerate
  // each cart custom element.
  var mo = new MutationObserver(function () { scheduleScan(); });
  mo.observe(document.body, { childList: true, subtree: true, characterData: true });

  // Cart events fired by the configurator / theme: belt-and-braces.
  ['variant:add', 'cart:change', 'cart:refresh', 'on:cart:update'].forEach(function (ev) {
    document.addEventListener(ev, scheduleScan);
    document.documentElement.addEventListener(ev, scheduleScan);
  });
})();
